import { useQueryClient } from '@tanstack/react-query';

import { usePolling } from '~src/lib/hooks/usePolling';

import { fetchPendingShipments, usePendingShipmentQueryKey } from './queries';

export function usePendingShipmentPolling() {
  const pendingKeys = usePendingShipmentQueryKey();
  const queryClient = useQueryClient();

  return usePolling(fetchPendingShipments, {
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: pendingKeys.lists() });
    },
  });
}
